import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';

import CustomRoute from '../CustomRoute';

const SwitchInnerRoutes = ({ route }) => {
  return (
    <Switch>
      {route.routes?.map((r) => (
        <CustomRoute key={r.key} {...r} component={r.component} />
      ))}
    </Switch>
  );
};

SwitchInnerRoutes.propTypes = {
  route: PropTypes.object.isRequired,
};

export default SwitchInnerRoutes;
